import React from 'react';
import { Link } from 'gatsby';
import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import p1 from "../assets/images/btn.png";
import s0 from "../assets/images/s0.png";
import i0 from '../assets/images/iraivan-0.jpg';
import i1 from '../assets/images/iraivan-1.jpg';
import pillarClose from '../assets/images/pillar-close.jpg'


import config from '../../config';
//import { url } from 'inspector';
const IndexPage = () => (
  <Layout>
    <section id="banner">
      <div className="inner" >
        <h2>{config.heading}</h2>
        <p>{config.subHeading}</p>
        <ul className="actions special">
          <li>
            <Scroll type="id" element="scroll-temple">
              <a href="/#" className="button primary">
                Explore
              </a>
            </Scroll>
          </li>
        </ul>
      </div>
      <Scroll type="id" element="one">
        <a href="#one" className="more">
          Learn More
        </a>
      </Scroll>
    </section>




    <section id="one" className="wrapper alt style2">

      <section   className="wrapper alt  ">
        <div className="inner">
          <h2 style={{ textAlign: "center", paddingTop: 20 }}>Divinity in Stone</h2>
        </div>
      </section>

      <section className="spotlight">
        <div className="image">
          <img src={i0} alt="" />
        </div>

       
        <div className="content">
          <h3>
            Where Heaven Meets Earth
          </h3>
          <p>
          A sunset view of Iraivan Temple, nestled on the banks of the Wailua River, regarded as sacred by the Hawaiians. Located in the heart of a traditional Hindu monastery complex reminiscent of India’s ancient mathas and aadheenams, Iraivan is more than a temple. It is a pilgrimage destination, a place of sadhana and spiritual renewal.
          </p>
        </div>
      </section>
      <section className="spotlight">
        <div className="image">
          <img src={i1} alt="" />
        </div>
        <div className="content">
          <h3>
          Abode of God Siva
           
          </h3>
          <p>
          Designed in the Chola Empire style of a thousand years ago, Iraivan Temple is regarded as the holy abode and body of God Siva. Within its chambers there is only Siva, no other Gods or divinities. This is how the most ancient Siva temples were.
          </p>
          
        </div>
      </section>
      <section className="spotlight">
        <div className="image">
          <img src={pillarClose} alt="" />
        </div>
        <div className="content">
          <h3>
          Pictorial Pillars
           
          </h3>
          <p>
          Gurudeva decreed that the temple be “a library in stone,” and had 24 of the pillars carved with sacred and cultural symbols. At the bottom are 24 of the traditional forms of God Siva. In the middle are depicted cultural and philosophical images. The top of each pillar has sacred symbols and plants, half from India and half from Hawaii. The pillars have much to teach about our spiritual tradition.
          </p>
          
        </div>
      </section>
      <div style={{paddingTop:24}} id="scroll-temple">
          </div>
    </section>

    <section id="two" className="wrapper alt style2" >

      <div className="inner">
        <h2 style={{ textAlign: "center", paddingTop: 24 }}>Choose a Pillar:</h2>
      </div>
      <div style={{ padding: 22, paddingTop: 40, backgroundColor: '#475251' }}>
        <div className="background-image-temple back-l-r-padding" >
          <div className="row gtr-30 gtr-uniform">
            <div className="col-3"><Link to="/Pillar11/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar12/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar13/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar14/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar10/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><Link to="/Pillar15/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar09/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><Link to="/Pillar16/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar8/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><Link to="/Pillar17/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar07/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><Link to="/Pillar18/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar06/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><Link to="/Pillar19/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar05/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><Link to="/Pillar20/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar04/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><Link to="/Pillar21/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar03/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><span className="image oversized"><img src={s0} alt="" /></span></div>
            <div className="col-3"><Link to="/Pillar22/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar02/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar01/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar24/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
            <div className="col-3"><Link to="/Pillar23/"><span className="image oversized"><img src={p1} alt="" /></span></Link></div>
          </div>
        </div>


      </div>

    </section>
     

    <section id="cta" className="wrapper style4">
      <div className="inner">
        <header style={{paddingTop:20}}>
          <h2>Wanting to Donate?</h2>
          <p>
           Give to Iraivan Temple's Building Fund and Sponsor a Stone
          </p>
        </header>
        <ul className="actions stacked">
          <li>
            <a href="https://www.hheonline.org/donate/iraivan_temple.shtml" className="button fit primary">
              Donate 
            </a>
          </li>
          <li>
            <a href="https://www.hheonline.org/donate/iraivan_temple_stone-sponsor.shtml" className="button fit">
              Sponsor
            </a>
          </li>
        </ul>
      </div>
    </section>
  </Layout>
);

export default IndexPage;
